var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproachIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.999512,
    width: 34,
    height: 34,
    fill: "url(#pattern0_67_358)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_67_358",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_67_358",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.4709,
    height: 33.4709,
    fill: "white",
    transform: "translate(0.625977 0.0397949)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_67_358",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEzElEQVR4nO2dW6hWRRTHx0ul0oUUj5CGBaJi+SQEQQ9ZByOMrOBY4q0XjR68PaqZB9EuCBaByTmVQmKRJiERYkXe82CCPondsEwjz4NHu4HXX0yO9Ekz2++Tb2YWzvrBfpuz13/mv/d39p61ZrYxiqIoiqIoiqIoiqIoXoA+wHhgMfAW0BHpsOde5GL1UTv8ZjwN/Eh6fgAmqSlXm/EycIl82NhL1JTLZsxADlOLNgW4DehGDr8Bt5pSAZ5HHtNNqQDrAoNyFtgCbIx0bHExfKw1pQJsCwzKGwlivxmIvc2UCrA9MCjtCWK3B2JvN6WihghDDRGGGiIM97Tj4yvgLuDOSMfQiovhE1MqwDLk0W5KBRgNXEQOF4FRpmSAd5HDO6Z0Kl7QcrDKlAxwL3AeOZwH7jGlAryEPBaZUrGPmIFB2Qc8AIyLdNhzdwVibzaloi+GwlBDhKGGCEMNEQbwReAf68oEsVcGYn9uSqUihfuHTaVGLJSzcf8MxH7PlAowBXk8Z0oFuBn4CTkctZpMyQBzkMMcUzKuuPoIcjhcdPE18AzyeMqUis0/CCyU6zSlooVywtA3dWGoIREBBgAjGsxLHAj8jnfUtBkLtDRBX4s715Xz2hg+DjTYB9vnAUYCQC/gWWAXcIG4/Ay8CgxsQN9A4DXgWGRtF9wYtNkxiTvq4c7eAWwlPSeBR+oohns002Kgz4DbU5txU8XvvwK7gVtSGrJER/2aLE5lRn/gzLX1FM9poF8KQyYWP9T183gKQ+ZX/LMdE6FSvaViiqUROt25mq1vTMXDw7wUhiwNBN8RMWZbEwxpi6hvRyDm0lgxs67NI2zIKc+L2qkMhmRbKynNkG5P29DPhxqihpDkDrHbGvk4GDHm7EDM4562xwNtZ0XUdygQc2GsmLXBpxJmZ4Rk0magJxBvj0ff14G2Pe5czdZn+xxiSgpDhgDnELp0ADlLHM42Y5a6XlPsM31ueoBBHm2D4d+35Nx0JDHDddrmFXLzdoW+NbnF2TFKaciHuXsL/GXXsnu0DQP+zi0O2JDKjGEJklH1ssyjbzkysGM0NPemY5siFEZ3Ar8G4nV59O0PtD3hztVsfR9XjMeMFIbYLVx97M9wEZzwtA2ZNzOivm+y5UR06uT/6FzWf+hclt4h8u6QHPmQyU24QybfqPmQeYHgNg/RGmmh/6ZAzCMefd8G2n4USVtrxVzb3BSGPIQc1nv0fYAcHkxhSG+3sEUCrR59E5CBXYjUO7ohrtOTcvcW2Hod+wGn5MkkZrgOT8/dW2CPr47W3cF7c4sDpqUsI7WFz0i8Crn8HRIJ2NXFfVMYYgudpbDRo89mBaXwcApDFggqlPvOo+97QYVy80srlOsWUgakhXLCDNFCOYcaopOL8u6QhYIK5X7xtC2uUG4mcgrluhpI4eYolEuSwh2e+ZuDtbzi0fc6MrBjdHd0Q1yn7UpTCZWBIzzaRgqprPw0iRk1XzX4XVoJ0BWAFZm12TWYI01KgMfc3og5eL9qattNMK7PpM1eqBOSmlHT8fvd13BScRJ4oZ7dEtwuEy8m3jzgSzuVkmb0qzt/n0vtropQiLbafbx44vUsM7Z/AzzhzrE6gj7b57kijFAURVEURVEURVEUxTSXfwDENbenHPvwxgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproachIcon3);
export default __webpack_public_path__ + "static/media/approach-icon-3.c85f1177e87f83419e0c4d3a8575fa3d.svg";
export { ForwardRef as ReactComponent };